module.exports = __webpack_public_path__ + "static/retritment-solution-56a15fc876fc80b4e563fed89df8d866.png";